import React from 'react';
import PropTypes from 'prop-types';

export const Article = ({ as: Component = 'h2', title, children }) => {
	return (
		<article id={title.toLowerCase()}>
			<Component className="article-title">{title}</Component>
			{children}
		</article>
	);
};

Article.propTypes = {
	as: PropTypes.elementType,
	title: PropTypes.string.isRequired,
	children: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.arrayOf(PropTypes.element),
	]).isRequired,
};
